import { request } from "./http";

export interface ExposureRow {
  symbol: string;
  net_qty: string;
  avg_price: string;
  last_update: number;
}

export interface HedgeRow {
  id: string;
  symbol: string;
  side: "BUY" | "SELL";
  qty: string;
  mode: "AUTO" | "MANUAL";
  status: "PENDING" | "APPROVED" | "REJECTED" | "SUBMITTED" | "FILLED" | "CANCELED";
  net_exposure_before: string;
  threshold_lots: string;
  source_order_ids: string[];
  reason: string | null;
  created_at: string;
  decided_at: string | null;
}

export interface LPHealthRow {
  name: string;
  connected: boolean;
  last_message_at: string | null;
  in_seq: number;
  out_seq: number;
  rtt_ms: number | null;
  fill_rate_pct: number | null;
  reject_rate_pct: number | null;
  last_error: string | null;
}

export interface ManualHedgeBody {
  symbol: string;
  side: "BUY" | "SELL";
  qty: string;
  lp_session_id?: string;
  note?: string;
}

export const dealingDesk = {
  exposure: () => request<ExposureRow[]>("/api/v1/dealing-desk/exposure"),
  pendingHedges: () => request<HedgeRow[]>("/api/v1/dealing-desk/hedges/pending"),
  recentHedges: (limit = 100) =>
    request<HedgeRow[]>(`/api/v1/dealing-desk/hedges?limit=${limit}`),
  fireHedge: (body: ManualHedgeBody) =>
    request<HedgeRow>("/api/v1/dealing-desk/hedges", { body }),
  approveHedge: (id: string) =>
    request<{ id: string; status: string; decided_at: string }>(
      `/api/v1/dealing-desk/hedges/${id}/approve`,
      { body: {} }
    ),
  rejectHedge: (id: string) =>
    request<{ id: string; status: string; decided_at: string }>(
      `/api/v1/dealing-desk/hedges/${id}/reject`,
      { body: {} }
    ),
  lpHealth: () => request<LPHealthRow[]>("/api/v1/dealing-desk/lps"),
};
